// extracted by mini-css-extract-plugin
export default {"select":"bwIw36","regular":"Y8NqRF","bold":"sYP6Ks"};